export default function ({state, rootGetters, commit, dispatch}) {
    dispatch('get', {
        id: state.id,
        type: state.type,
        cb: (data) => {
            commit('form/data', data.Certificate);
            commit('loading');
            let pType = rootGetters['dictionaries/paymentType/select/list'].filter(i => {
                return i.value === data.PaymentData.PaymentTypeId;
            })[0];
            commit('payment/data', {
                data: data.PaymentData,
                category: pType.category,
            });
        }
    })
}